import React from 'react';
import {  datosBauExterno, reduccionesExterno, bauMitigacionExterno, bauReal } from '../pages/Home';
import { Line }            from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

function LineReduccion( props ) {
    const [data, setData] = React.useState(null);
    const [datosListos, setDatosListos] = React.useState(false);
    const datoYears = [];
    const datoBau = [];
    
    const datoMitigacion = [];

    const renderLineReduccion =  () => {
        let datoHuella = [];
        
        setDatosListos(false);
        //console.log(bauMitigacionExterno);
        if (bauMitigacionExterno !== null && bauMitigacionExterno.length > 0) {

            bauMitigacionExterno.map((dato) => {
                Object.entries(dato).map(([key, value]) => {
                    //console.log(key + ' -- '+value);
                    Object.entries(value).map(([key1, value1]) => {
                        //console.log(key1 + ' -- '+value1);
                        if(key === 'mitigacion') {
                            datoMitigacion.push(value1);
                            datoYears.push(key1);
                        }
                        if(key === 'bau') {
                            datoBau.push(value1);
                        }
                    })
                })                
            })
            
            datoHuella = [];
            //console.log(bauReal);
            bauReal.map(real => {
                //console.log('bauReal year ='+real.year);
                
                datoYears.map(y => {
                    if (Number(y) === Number(real.year)) {
                        console.log('datoYear = '+y+' , bauReal Year = '+real.year);
                        console.log('bauReal == '+real.bauTotal);
                        if (Number(real.bauTotal > 0)) {
                            datoHuella.push(real.bauTotal)
                        }
                        
                    }
                })
            })
            //console.log('DATOS ********* datoHuela == '+datoHuella);
            

            const dataBauRed = {
                labels: datoYears, //["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
                datasets: [
                {
                    label: "Escenario BAU",
                    lineTension: 0.5,
                    data: datoBau,
                    fill: false,
                    backgroundColor: "rgba(75,192,192,0.2)",
                    borderColor: "#CA323E"
                },
                {
                    label: "Esc. mitigación proyectado",
                    lineTension: 0.5,
                    data: datoMitigacion,
                    fill: false,
                    borderColor: "#115BFF"
                },
                {
                    label: "Huella carbono",
                    lineTension: 0.5,
                    data: datoHuella,
                    fill: false,
                    borderColor: "#11FF11"
                }
                ]
            }
            setData(dataBauRed);
            setDatosListos(true);
        }
    }

    React.useEffect(() => {
        setData(null);
        const timer = setTimeout(() => {
            renderLineReduccion();
            //console.log('Enviando actualizar')
        }, 1000);
        return () => clearTimeout(timer);
    }, [bauMitigacionExterno])
    
  
    return (
        <div>
            { (data !== null) ?
                <Line data={data}/>
                :
                <img src='/loading.gif'></img>
            }
        </div>
    )
}

export { LineReduccion };